import { render, staticRenderFns } from "./ArticleCarousel.vue?vue&type=template&id=df3a0cd0&scoped=true&"
import script from "./ArticleCarousel.vue?vue&type=script&lang=js&"
export * from "./ArticleCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCarousel.vue?vue&type=style&index=0&id=df3a0cd0&scoped=true&lang=css&"
import style1 from "./ArticleCarousel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3a0cd0",
  null
  
)

export default component.exports